import { object, string } from "yup";

export const openingBalanceEditSchema = () =>
  object({
    opening_balance: string().required("Please enter opening balance"),
    opening_balance_date: string().required(
      "Please enter opening balance date"
    ),
  });
